import * as React from "react";
const MenuHome = ({ color = "#276AA6", ...props }) => (
  <svg
    width={22}
    height={22}
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.0009 15.5026H10.0012C9.17136 15.5026 8.50146 16.1725 8.50146 17.0023V20.5018H13.5007V17.0023C13.5007 16.1725 12.8308 15.5026 12.0009 15.5026Z"
      stroke={color}
      strokeWidth={1.5}
      strokeMiterlimit={10}
      strokeLinejoin="round"
    />
    <path
      d="M9.07198 1.82451L2.14302 7.37368C1.36314 7.99358 0.863215 9.30338 1.03319 10.2832L2.36299 18.242C2.60295 19.6618 3.96275 20.8116 5.40253 20.8116H16.6008C18.0306 20.8116 19.4004 19.6518 19.6404 18.242L20.9702 10.2832C21.1302 9.30338 20.6302 7.99358 19.8603 7.37368L12.9314 1.83451C11.8616 0.974642 10.1318 0.974642 9.07198 1.82451Z"
      stroke={color}
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default MenuHome;